import React from 'react'

export const Footer = () => {

  return (
    <footer>
      <div className="footer">
        Made by Peggy @<a href="https://blipsandclicks.com">blipsandclicks</a> during Technigo Bootcamp 2020 for educational purposes.
      </div>
    </footer>  
  )
}